/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {Pill} from '@instructure/ui-pill'
import {IconCheckMarkLine} from '@instructure/ui-icons'
import {useScope as createI18nScope} from '@canvas/i18n'

const I18n = createI18nScope('rubrics-assessment-status')

type AssessmentStatusPillProps = {
  isRubricComplete: boolean
}
export const AssessmentStatusPill = ({isRubricComplete}: AssessmentStatusPillProps) => {
  const renderIcon = isRubricComplete ? <IconCheckMarkLine /> : undefined
  const pillColor = isRubricComplete ? 'success' : 'warning'

  return (
    <Pill
      renderIcon={renderIcon}
      color={pillColor}
      margin="x-small"
      data-testid="rubric-assessment-status-pill"
    >
      {isRubricComplete ? I18n.t('Complete') : I18n.t('Incomplete')}
    </Pill>
  )
}
